import { render, staticRenderFns } from "./Textarea.vue?vue&type=template&id=6334f28c"
import script from "./Textarea.vue?vue&type=script&lang=js"
export * from "./Textarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6334f28c')) {
      api.createRecord('6334f28c', component.options)
    } else {
      api.reload('6334f28c', component.options)
    }
    module.hot.accept("./Textarea.vue?vue&type=template&id=6334f28c", function () {
      api.rerender('6334f28c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/standardTab/Textarea.vue"
export default component.exports